






import { TableColumn } from "element-ui/types/table-column";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class ListTemplateComponent extends Vue {
  @Prop()
  public name?: string;

  @Prop()
  private selectionChange?: (selectedItems: any[]) => {};

  @Prop()
  private filter?: (selectedItems: any[]) => {};

  private items: any[] = [];

  private emitEvents = true;

  public initialize(items: any[]) {
    this.emitEvents = false;
    this.items = items;
    this.$nextTick(() => {
      if (this.items && this.items.length) {
        this.items.forEach((item, _) => {
          (this.$refs.table as any).toggleRowSelection(item, item.visible);
        });
      }
      this.emitEvents = true;
    });
  }

  private filterItems(items: any[]) {
    if (this.filter) {
      return this.filter(items);
    }

    return items;
  }

  private openItem(item: any, cell: TableColumn, event: any) {
    this.$emit("open", item);
  }

  private handleSelectionChange(val: any[]) {
    if (this.selectionChange && this.emitEvents) {
      this.selectionChange(val);
    }
  }
}
